import {
  LoginConstants,
  pageRouteConstants,
  urlParameterConstants,
} from "../../constants/constants";
import PhoneNumberIconForLogin from "../../assets/images/PhoneNumberIconForLogin";
import UserIdPasswordIconForLogin from "../../assets/images/UserIdPasswordIconForLogin";
import FingerPrintLoginIconForLogin from "../../assets/images/FingerPrintLoginIconForLogin";
import FaceRecognitionIconForLogin from "../../assets/images/FaceRecognitionIconForLogin";
import Button from "./cta/Button";
import { useNavigate } from "react-router";
import CameraPopup from "./CameraPopup";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store/store";
import { readFromLocalStorage } from "../../utils/DataEncryption";
import { PopupMessage } from "./SideMenuStaffVerification";
import PopupModal from "./PopupModal";
import LoaderPopupModel from "./LoaderPopup";

export const PhoneNumberOtpLoginComponent = ({
  selectedLoginMethod,
  loginMethods,
  buttonPadding,
}: {
  selectedLoginMethod: any;
  loginMethods: any;
  buttonPadding: any;
}) => {
  const navigate = useNavigate();
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const [isCameraActive, setIsCameraActive] = useState(false);
  const [isFaceLoginOn, setIsFaceLoginOn] = useState(false);
  const [confirmedImage, setConfirmedImage] = useState(false);
  const [capturedFileImage, setCapturedFileImage] = useState<File | undefined>(
    undefined
  );
  const queryParams = new URLSearchParams(window.location.search);
  const appId = queryParams.get(urlParameterConstants.appId) || readFromLocalStorage("appId");
  const callbackUrl = queryParams.get(urlParameterConstants.callbackUrl) || readFromLocalStorage("callBackUrl");
  const scp = queryParams.get("scp") || readFromLocalStorage("scp");
  const [capturedImage, setCapturedImage] = useState<string | undefined>();
  const [showPopup, setShowPopup] = useState(false);
  const [popUpMsg, setPopUpMsg] = useState<PopupMessage>({
    title: "",
    message: "",
  });
  const [videoSize, setVideoSize] = useState({ width: "100%", height: "100%" });
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const isMobile = /Mobi|Android|iPhone/i.test(navigator.userAgent); // Detects mobile devices

    setVideoSize(
      isMobile
        ? { width: "100%", height: "250px" } // Mobile: Full width, smaller height
        : { width: "100%", height: "200px" } // Desktop: Fixed size
    );
  }, []);

  const startCamera = async () => {
    if (isCameraActive) return; // Prevent reactivation if already active

    setCapturedImage("");
    setIsCameraActive(true);
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      if (videoRef.current) {
        videoRef.current.srcObject = stream;
        videoRef.current.style.width = videoSize.width;
        videoRef.current.style.height = videoSize.height;
      }
    } catch (error: any) {
      setIsCameraActive(false);
      if (error.name === "NotFoundError") {
        handleAlert("Camera not found.");
      } else if (error.name === "NotAllowedError") {
        handleAlert("Permission to access camera was declined.");
      } else {
        handleAlert("Error accessing camera.");
      }
    }
  };

  const captureImage = () => {
    const canvas = document.createElement("canvas");
    if (videoRef.current) {
      canvas.width = videoRef.current.videoWidth * 0.8;
      canvas.height = videoRef.current.videoHeight * 0.6;
      canvas
        ?.getContext("2d")
        ?.drawImage(videoRef.current, 0, 0, canvas.width, canvas.height);

      let dataUri = canvas.toDataURL("image/jpeg");
      setCapturedImage(dataUri);
      let byteString = atob(dataUri.split(",")[1]);
      let mimeString = dataUri.split(",")[0].split(":")[1].split(";")[0];
      let ab = new ArrayBuffer(byteString.length);
      let ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      let blob = new Blob([ab], { type: mimeString });
      let file = new File([blob], "image.jpg", { type: mimeString });
      setCapturedFileImage(file);
    }
    closeCamera();
  };

  const handleCrossButton = () => {
    closeCamera();
    setCapturedImage(undefined);
    setIsFaceLoginOn(false);
  };
  const closeCamera = () => {
    if (videoRef.current && videoRef.current.srcObject) {
      const stream = videoRef.current.srcObject as MediaStream;
      stream.getTracks().forEach((track) => {
        console.log("Stopping track:", track);
        track.stop(); // Stop each track
      });

      // Ensure the video source is removed
      videoRef.current.srcObject = null;
    }

    // Reset state
    setIsCameraActive(false);
  };
  const handleLogin = () => {
    if (selectedLoginMethod !== "FID") {
      navigate(pageRouteConstants.ssoLogin, {
        state: {
          selectedMethod: selectedLoginMethod === "UID" ? 1 : 0,
          callBackUrl: callbackUrl,
          appId: appId,
          scp: scp,
        },
      });
    }
  };
  const handleLoginButton = () => {
    if (selectedLoginMethod === "FID") {
      capturedImage === undefined ? captureImageForLogin() : handelFaceLogin();
    } else {
      handleLogin();
    }
  };
  const captureImageForLogin = () => {
    setIsFaceLoginOn(true);
    startCamera();
  };
  const handelFaceLogin = () => {
    sendImageToBackend();
  };
  const SelectedLoginMethodIcons: Record<string, React.ComponentType<any>> = {
    OTP: PhoneNumberIconForLogin,
    UID: UserIdPasswordIconForLogin,
    FID: isFaceLoginOn
      ? () => (
          <CameraPopup
            setCapturedImage={setCapturedImage}
            setConfirmedImage={setConfirmedImage}
            videoRef={videoRef}
            capturedFileImage={capturedFileImage}
            captureImage={captureImage}
            capturedImage={capturedImage}
            startCamera={startCamera}
            setIsCameraActive={setIsCameraActive}
            popUpMsg={""}
            popUpTitle={""}
            isOpen={isFaceLoginOn}
            isVerifyImage={false}
            addImageToUserInfo={handelFaceLogin}
            onClose={handleCrossButton}
            closeCamera={closeCamera}
            buttonText={LoginConstants.ConfirmAndLogin}
          />
        )
      : () =>
          capturedImage ? (
            <img src={capturedImage} alt="Captured" />
          ) : (
            <FaceRecognitionIconForLogin />
          ),
    3: FingerPrintLoginIconForLogin,
  };

  const SelectedIcon = SelectedLoginMethodIcons[selectedLoginMethod];

  const handleError = (error?: any) => {
    setShowPopup(true);
    setPopUpMsg({ title: "Error", message: error });
  };
  const sendImageToBackend = () => {
    setIsLoading(true); // Start loader
    const formData = new FormData();
    const urlString = window.location.href;
    const url = new URL(urlString);
    const params = new URLSearchParams(url.search);

    const faceAPIBaseURL = `${process.env.REACT_APP_LOGINURL}/auth/v1/app`;
    const appIdFromParms = params.get("app_id");
    const scpFromParms = params.get("scp");
    const appId =
      appIdFromParms ||
      readFromLocalStorage("appId") ||
      process.env.REACT_APP_APPID;

    const scp = scpFromParms || process.env.REACT_APP_SCP_URL;

    if (capturedFileImage) {
      formData.append("face", capturedFileImage, "faceImage.png");
    }

    fetch(`${faceAPIBaseURL}/face-login`, {
      method: "POST",
      body: formData,
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((errData) => {
            throw new Error(
              errData.errorMessage || "An error occurred during face login."
            );
          });
        }
        return response.json();
      })
      .then((data) => {
        if (
          !data ||
          typeof data.b2cId !== "string" ||
          data.b2cId.trim() === "" ||
          data.status !== "ACTIVE"
        ) {
          throw new Error("The User is not Registered or Inactive");
        }

        const b2cId = encodeURIComponent(data.b2cId);
        const b2cLoginURL = `${faceAPIBaseURL}/token?app_id=${appId}&aut=FID&lhi=${b2cId}&scp=${scp}`;
        window.location.href = b2cLoginURL;
      })
      .catch((error) => {
        setIsLoading(false); // Stop loader
        handleError(error.message || "An unexpected error occurred.");
      });
  };

  const selectedMethod = loginMethods.find(
    (method: any) => method.method === selectedLoginMethod
  );
  return (
    <div className="">
      <div className={"flex justify-center text-body1Regular "}>
        {selectedMethod?.label}
      </div>

      <div className="mt-[2vh] rounded-lg flex justify-center items-center ">
        {SelectedIcon && <SelectedIcon />}
      </div>
      {selectedLoginMethod === "FID" && (
        <div className="flex justify-center">
          <Button
            handleClick={
              capturedImage === undefined
                ? () => captureImageForLogin()
                : () => {
                    handelFaceLogin();
                  }
            }
            buttonText={LoginConstants.CaptureImage}
            className={`
                ${buttonPadding.padding1}    focus:ring-4 focus:ring-gray-300 bg-primary mt-[2vh] md:mt-[2vh] text-white py-3  rounded-md transition duration-300 whitespace-nowrap
            `}
          />
        </div>
      )}
      {selectedLoginMethod !== "FID" && (
        <div className="flex justify-center">
          <Button
            handleClick={handleLoginButton}
            buttonText="Login"
            className={`    ${buttonPadding.padding2}          focus:ring-4 focus:ring-gray-300 bg-primary mt-[2vh] md:mt-[2vh] text-white py-3  rounded-md transition duration-300
            `}
          />
        </div>
      )}
      {showPopup && (
        <PopupModal
          popUpTitle={popUpMsg.title}
          popUpMsg={popUpMsg.message}
          buttonText="Okay"
          isOpen={showPopup}
          onClose={() => {
            setCapturedImage(undefined);
            setShowPopup(false);
            setIsFaceLoginOn(false);
          }}
          isSucessMessage={false}
        />
      )}
      {isLoading && <LoaderPopupModel isOpen={isLoading} />}
    </div>
  );
};
function handleAlert(arg0: string) {
  throw new Error("Function not implemented.");
}
